export default "__VITE_ASSET__WrXVu7qN__"